module.exports = __webpack_public_path__ + "170b4bd580228b7d8d271c5881e6a48f.png";